var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6281",
    "data-name": "Rectangle 6281",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18920",
    "data-name": "Path 18920",
    d: "M40.533,41.715c.158-.215.313-.432.474-.645l5.6,5.6-4.768,3.49a5.343,5.343,0,0,1-1.019,4.194c-.272.348-.591.655-.887.982-1.114-1.119-2.234-2.232-3.348-3.351Q34.04,54.525,31.5,57.07h-.89v-.889q2.541-2.544,5.09-5.081-1.678-1.672-3.351-3.349c.176-.163.351-.328.526-.491a5.293,5.293,0,0,1,2.893-1.435,5.419,5.419,0,0,1,1.759.018q1.5-2.065,3.01-4.123M41.153,43q-1.375,1.891-2.757,3.776c-.117.155-.226.319-.348.469-.294-.055-.582-.143-.878-.185a4.1,4.1,0,0,0-2.985.73c-.007.028.024.041.038.06l5.6,5.6c.021.017.036.048.066.053a4.09,4.09,0,0,0,.7-3.206c-.049-.222-.1-.443-.151-.665l4.247-3.1Q42.918,44.759,41.153,43Z",
    transform: "translate(-30.61 -41.07)",
    fill: "#6d809f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.46fb8a2ddde1a50912a0970db9701d3b.svg";
export { ForwardRef as ReactComponent };